import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { BodyTextMedium } from 'Packages/FacetDesign/Components/BodyText';
import { FDTitleText } from '@facet-wealth/design';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('primaryText', {
    _component: () => FDTitleText,
  }, overrideReadOnly)
  .nameOverride('secondaryText', {
    _component: () => BodyTextMedium,
  }, overrideReadOnly);

export default metaOverrideSet;
